import { Component, Output, EventEmitter, Input } from '@angular/core';

export type ViewMode = 'table' | 'list';

@Component({
  selector: 'app-view-switcher',
  templateUrl: './view-switcher.component.html',
  styleUrls: ['./view-switcher.component.scss']
})
export class ViewSwitcherComponent {
  @Input() currentView: ViewMode = 'table';
  @Output() viewChange = new EventEmitter<ViewMode>();

  switchView(view: ViewMode): void {
    if (this.currentView !== view) {
      this.currentView = view;
      this.viewChange.emit(view);
    }
  }
}
